import * as React from 'react';
import { Form, Text, Select, TextArea } from 'react-form';
import { api } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { ProtoEdit, PropsEdit, StateEdit } from '@src/components/Proto';
import { Box, Modal } from '@src/components';

// typing
interface LocalProps extends PropsEdit {
}
interface LocalState extends StateEdit {
}


// style
const style = css`
    form {
        ${mixin.form}
    }
`;

// component
export class Truck extends ProtoEdit<LocalProps, LocalState> {
    
	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { id, onCancel } = this.props;
        const { data, values = {}, entity = null, error } = this.state;
        if (entity === null) return null;

        const types = data.types.map( v => ({ value: v.id, label: v.name }));
        const customers = data.customers.map( v => ({ value: v.id, label: v.name }));
        const brands = data.brands.map( v => ({ value: v.id, label: v.name }));
        const batteries = data.batteries.map( v => ({ value: v.id, label: v.name }));
        
		return (
            <Modal
                title={!id ? _('new_title', 'SettingsTruck') : _('edit_title', 'SettingsTruck', { name: entity.description } ) }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save(v)}
                        defaultValues={entity}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ values: formApi.getFormState().values }); }) }
                        >
                            <div className="fields">
                                <article>
                                    <label htmlFor="serialno">{_('field_serialno', 'SettingsTruck')}</label>
                                    <Text field="serialno" id="serialno" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="seriescode">{_('field_seriescode', 'SettingsTruck')}</label>
                                    <Text field="seriescode" id="seriescode" className="form-control" />
                                </article>
                                {/*<article>
                                    <label htmlFor="custid">Customer</label>
                                    <Select field="custid" id="custid" options={customers} className="form-control" />
                                </article>*/}
                                <article>
                                    <label htmlFor="battid">{_('field_battid', 'SettingsTruck')}</label>
                                    <Select field="battid" id="battid" options={this.addDefaultOption(batteries, _('default_option_none'))} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="brand">{_('field_brand', 'SettingsTruck')}</label>
                                    <Select field="brand" id="brand" options={brands} className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="model">{_('field_model', 'SettingsTruck')}</label>
                                    <Text field="model" id="model" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="type">{_('field_type', 'SettingsTruck')}</label>
                                    <Text field="type" id="type" className="form-control" />
                                </article>
                                <article>
                                    <label htmlFor="description">{_('field_description', 'SettingsTruck')}</label>
                                    <TextArea field="description" id="description" className="form-control" />
                                </article>
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={ this.state.busy }>
                                {_(`btn_save`, 'Settings')} 
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Truck.tsx